function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.747
}, /*#__PURE__*/React.createElement("path", {
  d: "M37.358 10.495C35.989 8.912 34.403 8 32.76 8c-2.436 0-3.874 1.342-3.965 3.686-.129 3.321-.118 7.976-.118 13.314 0 5.45-.125 10 .118 13.193.162 2.133 1.599 3.306 3.965 3.306 1.752 0 3.44-1.052 4.869-2.851M40.381 14.988a3 3 0 10-5.714-1.281M41.51 21.211a3.781 3.781 0 10-6.405-2.722",
  transform: "matrix(1.3403 0 0 1.3389 -10.78 -5.53)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.586 28.269a3.781 3.781 0 003.781-3.781c0-1.511-.587-2.715-1.868-3.32M40.865 34.245a3.78 3.78 0 00.501-6.373M35.152 35.688a3 3 0 105.568-1.551M28.75 33.829A3.276 3.276 0 0131.36 30M33.26 31a3.276 3.276 0 100-6.552M33.098 20.03a3.276 3.276 0 006.161-2.23M32.26 37a3.276 3.276 0 016.019-2.59M37.26 22a3.276 3.276 0 003.748 2.724M28.75 21.829A3.276 3.276 0 0131.36 18",
  transform: "matrix(1.3403 0 0 1.3389 -10.78 -5.53)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.002 10.495C21.371 8.912 22.957 8 24.6 8c2.436 0 3.874 1.342 3.965 3.686.129 3.321.118 7.976.118 13.314 0 5.45.125 10-.118 13.193-.162 2.133-1.599 3.306-3.965 3.306-1.752 0-3.44-1.052-4.869-2.851M16.979 14.988a3 3 0 115.714-1.281M15.85 21.211a3.781 3.781 0 116.405-2.722",
  transform: "matrix(1.3403 0 0 1.3389 -10.78 -5.53)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.774 28.269a3.781 3.781 0 01-3.781-3.781c0-1.511.587-2.715 1.868-3.32M16.495 34.245a3.78 3.78 0 01-.501-6.373M22.208 35.688a3 3 0 11-5.568-1.551M28.709 33.829A3.276 3.276 0 0026.099 30M24.1 31a3.276 3.276 0 110-6.552M24.261 20.03A3.276 3.276 0 0118.1 17.8M25.1 37a3.276 3.276 0 00-6.019-2.59M20.1 22a3.276 3.276 0 01-3.748 2.724M28.609 19.129a3.276 3.276 0 00-2.61-3.829",
  transform: "matrix(1.3403 0 0 1.3389 -10.78 -5.53)"
}));

var SvgBrain = function SvgBrain(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBrain, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Brain.f97889f4.svg";
export { ForwardRef as ReactComponent };